export const ApiDef_RuntimeOrder = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map